import store from 'app-store';
import _ from 'lodash';

import { SHOW_MODAL, HIDE_MODAL, MODAL_HIDDEN } from './action-types';


export const actions = { showModal, hideModal, modalHidden, showDeleteModal };

// Actions
export function showModal(options) {
  store.dispatch({
    type: SHOW_MODAL,
    modalState: options
  });
}

export function hideModal() {
  store.dispatch({
    type: HIDE_MODAL
  });
}

export function modalHidden() {
  store.dispatch({
    type: MODAL_HIDDEN
  });
}


export function showDeleteModal(options) {
  const defaults = {
    confirmText: 'Delete',
    confirmButtonClasses: 'btn-danger'
  };

  showModal(_.defaultsDeep({}, options, defaults));
}



// WEBPACK FOOTER //
// ./app/modules/modals/actions.js